
function updateSearchQuery(value){
    if (history.pushState) {
      var url = window.location.protocol + "//" + window.location.host + window.location.pathname + '?search_query='+value;
      
      window.history.pushState({path:url},'',url);
      gtag('event', 'search_query', { event_category : 'search',event_label : value });
  
    }
  }
  
  
    jQuery(document).ready(function(){    
      $('input.autocomplete').each(function(index,element){
        new autoComplete({
            data: {                              // Data src [Array, Function, Async] | (REQUIRED)
              src: async () => {
                const query = element.value //document.querySelector("#autocomplete").value;
                if(!query) return [];
                //updateSearchQuery(query);
                const source = await fetch(`https://api.ismash.com/app/search/${query}`);
                const data = await source.json();
                return data;
              },
              key: ["title"],
              cache: false
            },
            query: {
                  manipulate: (query) => {
                    return query.trim()
                  }
            },
            placeHolder: "Search...",
            selector: ()=>element,
            threshold: 0,
            debounce: 450,
            searchEngine: "strict",
            resultsList: {
                render: true,
                container: source => {
                    source.setAttribute("id", "results_list");
                },
                destination: document.querySelector("results-list-wrapper"),
                position: "afterend",
                element: "ul"
            },
            maxResults: 50,
            highlight: true, 
            resultItem: {
                content: (data, source) => {
                  $(element).parent().addClass('has_results');
                    source.innerHTML = data.match;
                },
                element: "li"
            },
            noResults: () => {
                const result = document.createElement("li");
                let search_term =  element.value //document.querySelector("#autocomplete").value;
                result.setAttribute("class", "no_result");
                result.setAttribute("tabindex", "1");
                result.innerHTML = `No results found for  <b>${search_term}</b>`;
                $(element).parent().find("#results_list").append(result);
            },
            onSelection: feedback => {
              gtag('event', 'result_click', { event_category:'search',event_label:feedback.selection.value.url });
              window.location.href=feedback.selection.value.url;
            }
        });
  
  
        $(element).on('input',function(event){
          if(this.value ==""){
            $(element).parent().removeClass('has_results');
          }
          
        })
  
      })
  
      $('.ismash-search-wrapper').on('click',function(){
  
  
        if(!$(this).hasClass('active')){
          gtag('event', 'icon_click', { event_category: 'search',event_label:"Search Icon"});
          $(this).addClass('active')
        }
      })
  
      $('.ismash-search-wrapper input').on('blur',function(){
        let el = document.querySelector('.active input.autocomplete')
        if(el){
          el.value="";
          el.dispatchEvent(new Event('input'))
        }
  
        //$('.ismash-search-wrapper').removeClass('active')
        //$('input.autocomplete').parent().removeClass('has_results');
              
      })
  
      
      $("#mobile_search_toggle").on('click',function(){
        gtag('event', 'icon_click', { event_category: 'search',event_label:"Search Icon"});
        $('.mobile_search_wrapper').slideToggle( "slow" );
        $('.open_icon').toggleClass('hidden')
        $('.close_icon').toggleClass('hidden')
      })
  
    
      var is_safari = navigator.userAgent.toLowerCase().indexOf('safari/') > -1 && navigator.userAgent.toLowerCase().indexOf('chrome/') < 0;
  
      if(is_safari){
        $('body').addClass('is_on_safari');
      }
  
    })